import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Geography } from "react-simple-maps";

export default function GeographyComponent({ geo, fill, data }) {
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const tooltip = show ? (
    <div
      style={{
        position: "fixed",
        top: pos.y,
        left: pos.x,
        background: "white",
        padding: "8px 10px",
        borderRadius: "6px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        pointerEvents: "none",
        zIndex: 9999,
        fontSize: "13px"
      }}
    >
      <strong>{geo.properties.name}</strong>
      <br />
      Users: {data?.Count ?? 0}
    </div>
  ) : null;

  return (
    <>
      <Geography
        geography={geo}
        fill={fill}
        onMouseEnter={(e) => {
          setShow(true);
          setPos({ x: e.clientX + 12, y: e.clientY + 12 });
        }}
        onMouseLeave={() => setShow(false)}
        onMouseMove={(e) =>
          setPos({ x: e.clientX + 12, y: e.clientY + 12 })
        }
        style={{
          default: { outline: "none" },
          hover: { fill: "#b565c7", outline: "none" },
          pressed: { outline: "none" },
        }}
      />

      {ReactDOM.createPortal(tooltip, document.body)}
    </>
  );
}
